import { useState } from 'react';
import Left from '../Navbar/Left';
import Mobile from '../Navbar/Mobile';
import { Blur, Body, Content } from './styles';
import { useTheme, type SxProps, type Theme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useUser } from '@/hooks/useUser';
import EditUser from '../EditUser';

function Layout({
  children,
  noLeftMargin = false,
  sx,
}: {
  children: React.ReactNode;
  noLeftMargin?: boolean;
  sx?: SxProps<Theme>;
}) {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const [expanded, setExpanded] = useState(false);

  const [editUserOpen, setEditUserOpen] = useState(false);
  const { user } = useUser();

  return (
    <div>
      <Body>
        {isMd ? (
          <Mobile
            expanded={expanded}
            setExpanded={setExpanded}
            onEditUser={() => setEditUserOpen(true)}
          />
        ) : (
          <Left
            expanded={expanded}
            setExpanded={setExpanded}
            onEditUser={() => setEditUserOpen(true)}
          />
        )}
        <Blur expanded={expanded}>
          <Box
            sx={sx}
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: isMd
                ? '100%'
                : expanded
                  ? 'calc(100vw - 240px)'
                  : 'calc(100vw - 72px)',
              height: '100vh',
              overflowY: 'auto',
            }}
          >
            <Content noLeftMargin={noLeftMargin}>{children}</Content>
          </Box>
        </Blur>

        {user && (
          <EditUser open={editUserOpen} setOpen={setEditUserOpen} user={user} />
        )}
      </Body>
    </div>
  );
}

export default Layout;
